import { IconButton } from "@mui/material";
import { Add, Edit } from "@mui/icons-material";
import { uniqueId } from "lodash";
import React, { useEffect, useState } from "react";
import useStyles from "./image_picker_styles";
import imageCompression from "browser-image-compression";

export default function ImagePicker({ imageUrl, setFile, file, title, readOnly, width, height }) {
  const classes = useStyles();
  const id = uniqueId();
  const [updatedImageUrl, setUpdatedImageUrl] = useState(null);

  const chooseImage = () => {
    document.getElementById(id).click();
  };

  const onChangeFile = async (file) => {
    const compressedFile = await imageCompression(file);
    setFile(compressedFile);
  };

  const processFile = (file) => {
    var fr = new FileReader();
    fr.onload = function () {
      setUpdatedImageUrl(fr.result);
    };
    fr.readAsDataURL(file);
  };

  useEffect(() => {
    if (file) {
      processFile(file);
    } else {
      setUpdatedImageUrl(null);
    }
  }, [file]);

  return (
    <div className={classes.image_row}>
      <div
        className={classes.image_container_outer}
        style={{ width: width || "150px", height: height || "150px" }}
      >
        <div
          className={classes.image_container}
          style={{
            backgroundImage: updatedImageUrl
              ? `url(${updatedImageUrl})`
              : imageUrl
              ? `url(${imageUrl})`
              : "none",
          }}
        >
          {title && <span className={classes.title}>{title}</span>}
          {readOnly ? (
            <div />
          ) : !imageUrl && !updatedImageUrl ? (
            <IconButton onClick={chooseImage} className={classes.add_button}>
              <Add className={classes.add_icon} />
            </IconButton>
          ) : (
            <div className={classes.edit_button_outer}>
              <IconButton onClick={chooseImage} className={classes.edit_button}>
                <Edit className={classes.edit_icon} />
              </IconButton>
            </div>
          )}
        </div>
      </div>
      <input
        type="file"
        accept="image/*"
        hidden
        id={id}
        onChange={(event) => {
          if (event.target.files[0]) {
            onChangeFile(event.target.files[0]);
          }
        }}
        onClick={(event) => {
          event.target.value = "";
        }}
      />
    </div>
  );
}
